/**
 * Created by pbo on 26/08/16.
 */

angular.module('taric.duty.meursing', [
    'common.model.geoarea',
    'taric.model.meursing',
    'common.config',
    'common.helper',
    'common.filter.geographicalarea.description',
    'common.directive.country',
    'taric.model.monetaryunits',
    'taric.model.links'
]).controller('SearchMeursingController', function ($window, CONSTANTS, $translatePartialLoader, MeursingModel, GeographicalAreaModel, $state, $stateParams, $rootScope, $scope, CommonHelper, $filter, MonetaryUnitsModel, TaricLinksSearchModel, $translate, countries, currencies, meursingItemLists, milkProteinsList, sucroseIsoglucoseList, $location) {
    var meurCtrl = this;

    meurCtrl.init = function () {
        meurCtrl.model = MeursingModel;
        meurCtrl.searchCriteria = meurCtrl.model.getSearchCriteria();
        meurCtrl.controlCountry = {};
        meurCtrl.dateFormat = CONSTANTS.dateFormat;
        meurCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        meurCtrl.loadMeursingLinks();

        if (!meurCtrl.searchCriteria.useAdditionalCode && meursingItemLists) {
            meurCtrl.model.milkFatList = meursingItemLists.milkFatList;
            if (milkProteinsList) {
                meurCtrl.model.milkProteinsList = milkProteinsList;
            } else {
                meurCtrl.model.milkProteinsList = meursingItemLists.milkProteinsList;
            }
            meurCtrl.model.starchGlucoseList = meursingItemLists.starchGlucoseList;
            if (sucroseIsoglucoseList) {
                meurCtrl.model.sucroseIsoglucoseList = sucroseIsoglucoseList;
            } else {
                meurCtrl.model.sucroseIsoglucoseList = meursingItemLists.sucroseIsoglucoseList;
            }

            meurCtrl.searchCriteria.milkFatId = CommonHelper.getValidSelectedItem(
                meurCtrl.model.milkFatList.items,
                meurCtrl.searchCriteria.milkFatId,
                null);

            meurCtrl.searchCriteria.milkProteinId = CommonHelper.getValidSelectedItem(
                meurCtrl.model.milkProteinsList.items,
                meurCtrl.searchCriteria.milkProteinId,
                null);

            meurCtrl.searchCriteria.starchGlucoseId = CommonHelper.getValidSelectedItem(
                meurCtrl.model.starchGlucoseList.items,
                meurCtrl.searchCriteria.starchGlucoseId,
                null);

            meurCtrl.searchCriteria.sucroseIsoglucoseId = CommonHelper.getValidSelectedItem(
                meurCtrl.model.sucroseIsoglucoseList.items,
                meurCtrl.searchCriteria.sucroseIsoglucoseId,
                null);
        }

        meurCtrl.model.dutyMonetaryUnits = currencies;
        meurCtrl.searchCriteria.dutyCurrency = CommonHelper.getValidSelectedItem(
            meurCtrl.model.dutyMonetaryUnits.items,
            meurCtrl.searchCriteria.dutyCurrency,
            CONSTANTS.installationCurrency);

        if (meurCtrl.isExternalLink() && meurCtrl.validateExternalParameters()) {
            if (countries){

                // get valid CountryCode
                meurCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(
                    countries.items,
                    meurCtrl.searchCriteria.country,
                    null);
            }

            // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
            meurCtrl.loadDataFromServerWithoutValidation();
        }
    };

    meurCtrl.isExternalLink = function(){
        return (!$stateParams.frm || ($stateParams.frm !== 'adcoLookup' && $stateParams.frm !== 'taric.measure.mcc' && $stateParams.frm !== 'taric.duty.calculate')) &&
            $stateParams.sd && $stateParams.cu &&
            ($stateParams.ad || ($stateParams.mf && $stateParams.mp && $stateParams.sg && $stateParams.si));
    };

    //Check whether the external parameters are valid or not
    meurCtrl.validateExternalParameters = function(){
        meurCtrl.resetError();
        return meurCtrl.validateSimulationDate() &&
            meurCtrl.validateAdditionalCode() &&
            meurCtrl.validateSelectLists() &&
            meurCtrl.validateMonetaryUnit();
    };

    meurCtrl.cancelButtonClicked = function() {
        $state.go(meurCtrl.model.from, {ad: '7XXX', frm: 'taric.duty.meursing'});
    };

    meurCtrl.returnToCallerPageWithAdditionalCode = function() {
        $state.go(meurCtrl.model.from, {
            frm: 'taric.duty.meursing',
            ad: CommonHelper.removeSpaceCharacters(meurCtrl.model.meursingResult.additionalCode)
        });
    };

    meurCtrl.loadMeursingLinks = function() {

        // Get meursing links
        TaricLinksSearchModel.searchTariffLinksType('MEURSING_INFORMATION').then(function(result) {
            meurCtrl.model.meursingLinks = result;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.clearSearchResults = function() {
        meurCtrl.model.meursingResult = {"additionalCode": null};
    };

    meurCtrl.loadMonetaryUnits = function () {
        MonetaryUnitsModel.dutyMonetaryUnits(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.dutyMonetaryUnits = result;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.loadMeursingItemLists = function () {
        if (!meurCtrl.searchCriteria.simulationDate) {
            return;
        }

        //Load from meursing items from database
        MeursingModel.initMeursingItemLists(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.milkFatList = result.milkFatList;
            meurCtrl.model.milkProteinsList = result.milkProteinsList;
            meurCtrl.model.starchGlucoseList = result.starchGlucoseList;
            meurCtrl.model.sucroseIsoglucoseList = result.sucroseIsoglucoseList;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.setMilkFatProteinLists = function() {
        meurCtrl.searchCriteria.milkFatId = null;
        meurCtrl.searchCriteria.milkProteinId = null;

        MeursingModel.initMeursingItemLists(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.milkFatList = result.milkFatList;
            meurCtrl.model.milkProteinsList = result.milkProteinsList;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.setStarchSucroseLists = function() {
        meurCtrl.searchCriteria.starchGlucoseId = null;
        meurCtrl.searchCriteria.sucroseIsoglucoseId = null;

        MeursingModel.initMeursingItemLists(meurCtrl.searchCriteria.simulationDate).then(function (result) {
            meurCtrl.model.starchGlucoseList = result.starchGlucoseList;
            meurCtrl.model.sucroseIsoglucoseList = result.sucroseIsoglucoseList;
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
        });
    };

    meurCtrl.updateSearchFields = function () {
        meurCtrl.resetError();
        if (!meurCtrl.searchCriteria.useAdditionalCode) {
            meurCtrl.searchCriteria.additionalCode = null;
            meurCtrl.resetMeursingListItem();
            meurCtrl.loadMeursingItemLists();
        } else {
            meurCtrl.resetMeursingListItem();
        }
        meurCtrl.clearSearchResults();
    };

    meurCtrl.resetMeursingListItem = function () {

        //Reset item list
        meurCtrl.model.milkFatList = {"items": []};
        meurCtrl.model.milkProteinsList = {"items": []};
        meurCtrl.model.starchGlucoseList = {"items": []};
        meurCtrl.model.sucroseIsoglucoseList = {"items": []};

        //Reset selected items
        meurCtrl.searchCriteria.milkFatId = null;
        meurCtrl.searchCriteria.milkProteinId = null;
        meurCtrl.searchCriteria.starchGlucoseId = null;
        meurCtrl.searchCriteria.sucroseIsoglucoseId = null;
    };

    meurCtrl.lookupAdditionalCode = function (additionalCode) {
        meurCtrl.resetError();
        $state.go('taric.adco.lookup', {
            frm: 'taric.duty.meursing',
            sd: CommonHelper.getBookmarkDateString(meurCtrl.searchCriteria.simulationDate),
            ad: CommonHelper.removeSpaceCharacters(additionalCode),
            mo: true
        });
    };

    meurCtrl.openDatePicker = function ($event) {
        meurCtrl.isDatePickerOpen = true;
    };

    meurCtrl.onDateChange = function (dateString) {
        meurCtrl.resetError();
        meurCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(meurCtrl.searchCriteria.simulationDate, dateString);
        if (!meurCtrl.searchCriteria.simulationDate) {
            return;
        }

        meurCtrl.searchCriteria.dutyCurrency = CONSTANTS.installationCurrency;
        meurCtrl.loadMonetaryUnits();
        meurCtrl.controlCountry.reload(meurCtrl.searchCriteria.simulationDate);
        meurCtrl.updateSearchFields();
    };

    //Check whether the search form is valid or not
    meurCtrl.validateForm = function () {
        meurCtrl.resetError();
        return meurCtrl.validateSimulationDate() &&
            meurCtrl.validateCountryCode() &&
            meurCtrl.validateAdditionalCode() &&
            meurCtrl.validateSelectLists() &&
            meurCtrl.validateMonetaryUnit();
    };

    meurCtrl.validateCountryCode = function(){
        meurCtrl.errorCode = meurCtrl.controlCountry.validate();
        return meurCtrl.errorCode === null;
    };

    meurCtrl.validateAdditionalCode = function() {
        if (!meurCtrl.searchCriteria.useAdditionalCode) {
            return true;
        }

        if (meurCtrl.searchCriteria.additionalCode === null || meurCtrl.searchCriteria.additionalCode === '') {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        return true;
    };

    meurCtrl.validateMonetaryUnit = function() {
        var  params = meurCtrl.searchCriteria;
        if (params.dutyCurrency === '') {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        return true;
    };

    meurCtrl.validateSelectLists = function() {
        var  params = meurCtrl.searchCriteria;

        if (params.useAdditionalCode) {
            return true;
        }
        if (params.milkFatId === null || params.milkFatId === '' ||
            params.milkProteinId === null || params.milkProteinId === '' ||
            params.starchGlucoseId === null || params.starchGlucoseId === '' ||
            params.sucroseIsoglucoseId === null || params.sucroseIsoglucoseId === '') {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        return true;
    };

    meurCtrl.validateSimulationDate = function () {
        if (meurCtrl.searchCriteria.simulationDate === undefined) {
            meurCtrl.errorCode = 'i8n.qry.meur.search.search.mandatoryFields.missing';
            return false;
        }
        if (!CONSTANTS.dateRestrictionEnabled) {
            meurCtrl.errorCode = CommonHelper.validateSimulationDate(meurCtrl.searchCriteria.simulationDate);
            if (meurCtrl.errorCode){
                meurCtrl.errorParams = {param0: CONSTANTS.pastDate};
            }
        }
        return meurCtrl.errorCode === null;
    };

    meurCtrl.resetError = function () {
        meurCtrl.errorCode = null;
        meurCtrl.errorParams = null;
        meurCtrl.errorType = null;
    };

    meurCtrl.updateCountry = function (country) {
        meurCtrl.resetError();
        meurCtrl.searchCriteria.country = country;
    };

    meurCtrl.updateMilkProteinItems = function () {
        if (meurCtrl.searchCriteria.milkFatId) {
            meurCtrl.model.updateMilkProteinItems(meurCtrl.searchCriteria.milkFatId, meurCtrl.searchCriteria.simulationDate).then(function (result) {
                meurCtrl.model.milkProteinsList = result;
                meurCtrl.searchCriteria.milkProteinId = null;
            }, function (error) {
                meurCtrl.errorCode = error.data.code;
                meurCtrl.errorParams = error.data.params;
                meurCtrl.errorType = error.data.type;
            });
        } else {
            meurCtrl.setMilkFatProteinLists();
        }
    };

    meurCtrl.updateSucroseIsoglucoseItems = function () {
        if (meurCtrl.searchCriteria.starchGlucoseId) {
            meurCtrl.model.updateSucroseIsoglucoseItems(meurCtrl.searchCriteria.starchGlucoseId, meurCtrl.searchCriteria.simulationDate).then(function (result) {
                meurCtrl.model.sucroseIsoglucoseList = result;
                meurCtrl.searchCriteria.sucroseIsoglucoseId = null;
            }, function (error) {
                meurCtrl.errorCode = error.data.code;
                meurCtrl.errorParams = error.data.params;
                meurCtrl.errorType = error.data.type;
            });
        } else {
            meurCtrl.setStarchSucroseLists();
        }
    };

    meurCtrl.search = function () {
        if (!meurCtrl.validateForm()) {
            return false;
        }

        meurCtrl.loadDataFromServerWithoutValidation();
    };

    //Load data without validation
    meurCtrl.loadDataFromServerWithoutValidation = function () {
        var r = {
            "additionalCode": null,
            "milkFat": null,
            "milkProteins": null,
            "starchGlucose": null,
            "sucroseIsoglucose": null,
            "ergaOmnesDutyRates": {"items": []},
            "otherDutyRates": {"items": []}
        };

        meurCtrl.searching = true;
        meurCtrl.clearSearchResults();
        meurCtrl.model.getMeursingResult().then(function (result) {
            r = result;
            r.ergaOmnesDutyRates = result.ergaOmnesDutyRates;
            r.otherDutyRates = result.otherDutyRates;
            meurCtrl.model.meursingResult = r;
            meurCtrl.searching = false;
            meurCtrl.updateBrowserURL();
        }, function (error) {
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
            meurCtrl.searching = false;
        });
    };

    meurCtrl.openMeursingPopup = function(meursingLinks) {
        var meursingLink = $filter('description')(meursingLinks);
        var meursingLinkPopupStyle = 'scrollbars=yes,resizable=yes,top=100,left=100,width=800,height=800';
        $window.open(meursingLink, '_blank', meursingLinkPopupStyle);
    };

    /**
     * Meursing
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/duty/meursing?sd={SimulationDate}&cu={Currency}&co={Country}&ad={AdditionalCode}&mf={MilkFat}&mp={MilkProteins}&sg={StarchGlucose}&si={SucroseIsoglucose}&l={Language}
     *
     * Example:
     * http://www.testenv.se/arctictariff-public-web/#!/taric/duty/meursing?sd=2015-01-01&cu=EUR&co=US&mf=01.010.0.0010&mp=01.020.0.0020&sg=01.010.1.0110&si=01.020.1.0140&l=en
     */
    meurCtrl.updateBrowserURL = function(){
        if (!CONSTANTS.enableBookmark){
            return;
        }

        // Keep additional parameters to return to caller page.
        $location.search({
            sd: CommonHelper.getBookmarkDateString(meurCtrl.searchCriteria.simulationDate),
            cu: meurCtrl.searchCriteria.dutyCurrency,
            co: meurCtrl.searchCriteria.country,
            ad: meurCtrl.searchCriteria.additionalCode,
            mf: meurCtrl.searchCriteria.milkFatId,
            mp: meurCtrl.searchCriteria.milkProteinId,
            sg: meurCtrl.searchCriteria.starchGlucoseId,
            si: meurCtrl.searchCriteria.sucroseIsoglucoseId,
            l : $translate.use(),
            frm: ($stateParams.frm !== 'adcoLookup') ? $stateParams.frm : null
        }).replace();
    };

    // export pdf
    meurCtrl.print = function(options){
    	
    	if (!meurCtrl.validateForm()) {
            $scope.$apply();
            return false;
        }

        $rootScope.$broadcast('startSpinningPrint');

        meurCtrl.model.getMeursingResult().then(function (result) {
            let r = result;
            r.ergaOmnesDutyRates = result.ergaOmnesDutyRates;
            r.otherDutyRates = result.otherDutyRates;
            meurCtrl.model.meursingAllResult = r;
            if (meurCtrl.model.meursingAllResult.additionalCode) {

                setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportFormTable'), options);
                    doc.push ({ text: '\n' });

                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportMeursingInfo'), options);
                    doc.push ({ text: '\n' });

                    // Do not repeat table header for Meursing on each pages.
                    options.headerRows = 0;
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        validDate: $filter('date')(meurCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.meur.search.search.title')
                    }, 'p').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
                    
                }, 1000);
            }
        }, function(error){

            // show errors here
            meurCtrl.errorCode = error.data.code;
            meurCtrl.errorParams = error.data.params;
            meurCtrl.errorType = error.data.type;
            $rootScope.$broadcast('stopSpinningPrint');
        });
    };

	$scope.$on('printDocument', function(event, data) {
		
		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, meurCtrl.print, true);
    });
});



// WEBPACK FOOTER //
// ./app/taric/duties/meursing/meursing-search.js